<div id="exampleModal">
    <div>
        <div class="modal-content no-border">
            <div class="modal-header no-border d-inline">
                <h5 class="modal-title font-weight-bold" id="exampleModalLabel">{{message}}</h5>
            </div>
            <div class="modal-footer p-0 flex-nowrap no-border">
                <button class="btn btn-danger float-left" type="button" (click)="closeDialog()">Odustani</button>

                <button class="btn btn-success float-right" type="button" (click)="deleteTask()">Potvrdi</button>
            </div>
        </div>
    </div>
</div>
